import React, { useEffect, useState, useRef } from "react";

// Ondas pequeñas que se difuminan donde el usuario toca (mouse o dedo).
const TapRipple = () => {
  const [ripples, setRipples] = useState([]);
  const idRef = useRef(0);

  useEffect(() => {
    const spawn = (x, y) => {
      const id = ++idRef.current;
      setRipples((prev) => [...prev, { id, x, y }]);
      setTimeout(() => {
        setRipples((prev) => prev.filter((r) => r.id !== id));
      }, 650);
    };

    const onPointerDown = (e) => {
      // Usa las coordenadas del puntero (funciona para mouse y touch)
      spawn(e.clientX, e.clientY);
    };

    window.addEventListener("pointerdown", onPointerDown, { passive: true, capture: true });
    return () => window.removeEventListener("pointerdown", onPointerDown, { capture: true });
  }, []);

  return (
    <div className="tap-ripple-layer" aria-hidden="true">
      {ripples.map((r) => (
        <span key={r.id} className="tap-ripple" style={{ left: r.x, top: r.y }} />
      ))}
    </div>
  );
};

export default TapRipple;
